export default __webpack_public_path__ + "static/media/AnaFernandezSpanishactualizado.40d47045.pdf";